/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSignalE = createReactComponent("signal-e", "IconSignalE", [
  ["path", { d: "M14 8h-4v8h4", key: "svg-0" }],
  ["path", { d: "M10 12h2.5", key: "svg-1" }]
]);

export { IconSignalE as default };
//# sourceMappingURL=IconSignalE.js.map
